import { useEffect, useRef } from 'react';

export default function MissionSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100', 'translate-y-0');
          entry.target.classList.remove('opacity-0', 'translate-y-6');
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-16 lg:py-24 bg-brand-dark-2">
      <div className="container mx-auto px-6">
        <div
          ref={ref}
          className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center opacity-0 translate-y-6 transition-all duration-700"
        >
          {/* Text left */}
          <div className="flex-1 max-w-xl">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
              Délais ambitieux, environnements sensibles, enjeux structurants ?
            </h2>
            <div className="space-y-4 text-gray-300 text-lg leading-relaxed">
              <p>
                Depuis 2016, ITEC Groupe accompagne les décideurs dans la réussite de leurs projets critiques avec une approche structurée, agile et sécurisée.
              </p>
              <p>
                Nous intervenons là où la précision, la réactivité et la rigueur d'exécution sont déterminantes.
              </p>
              <p>
                <strong className="text-white">Notre mission</strong> : faire avancer vos projets dans les environnements les plus exigeants, avec clarté, sérénité et engagement.
              </p>
              <p>
                <strong className="text-white">Notre méthode</strong> : mobilisation rapide d'experts qualifiés, coordination fluide et logique de résultats.
              </p>
            </div>
          </div>

          {/* Image right */}
          <div className="flex-1 w-full">
            <div className="relative w-full aspect-video rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://public.readdy.ai/ai/img_res/12a6963f6358ab0a8e1353126f901eff.jpg"
                alt="Portrait of a mature man using a laptop while working in a server room"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}